<template>
    <b-card no-body class="shadowed my-4">
        <bookmark/>
        <div class="p-4">
            <h6 class="text-primary text-uppercase">{{cardTitle}}</h6>
            <p><strong>{{trans('webinars.detail.topic')}}:</strong> {{webinar.title}}</p>
            <p><strong>{{trans('webinars.detail.date')}}:</strong> {{webinar.date}}</p>
            <p><strong>{{trans('webinars.detail.hour')}}:</strong> {{webinar.time}}</p>
            <p v-html="webinar.text"></p>

            <div class="d-flex justify-content-center" v-if="webinar.registeredSessions.length > 0">
                <div v-for="sessionId in webinar.registeredSessions">
                    <b-button
                        variant="link"
                        class="text-secondary px-0"
                        :href="sessionLink(sessionId)"
                        rel="noopener noreferrer"
                        target="_blank"
                        @click="trackGoToWebinar(sessionId)"
                    >
                        {{sessionTime(sessionId)}} {{trans('webinars.dashboard.go_to_webinar')}}
                    </b-button>
                </div>
            </div>

            <div class="d-flex justify-content-end mt-2">
                <div v-if="webinar.sessions.length === 1">
                    <b-button v-if="webinar.availableSessions.length === 1" @click="selectSession(webinar.availableSessions[0])">
                        {{trans('webinars.detail.session_card.register')}}
                    </b-button>
                </div>
                <div v-else-if="webinar.availableSessions.length > 0 && !webinar.anySessionPassed">
                    <b-dropdown variant="secondary" :text="multipleSessionText" toggle-class="px-4">
                        <b-dropdown-item v-for="sessionId in webinar.availableSessions" :key="sessionId"
                                         @click="selectSession(sessionId)">
                            {{sessionTime(sessionId)}}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
import Bookmark from "../../atoms/Bookmark";
export default {
    name: "WebinarSessionCard",
    components:{Bookmark},
    props:{
        webinar:{
            augmented: Boolean,
            topic: String,
            date: String,
            hour: String,
            detail: String,
            sessions: Array,
            availableSessions: Array,
            registeredSessions: Array
        }
    },
    methods:{
        sessionTime(sessionId) {
            return this.webinar.sessions.find(session => session.id === sessionId).time;
        },
        sessionLink(sessionId) {
            return this.webinar.sessions.find(session => session.id === sessionId).link;
        },
        selectSession(sessionId) {
            this.$router.push(`/webinar/session/${sessionId}`)
            trackEvent('WebinarSignupClick', {sessionId});
        },
        trackGoToWebinar(sessionId) {
            trackEvent('WebinarGoToClick', {sessionId});
        }
    },
    computed:{
        multipleSessionText(){
            return this.webinar.registeredSessions.length > 0
                ? this.trans('webinars.detail.session_card.other_session')
                : this.trans('webinars.detail.session_card.register');
        },
        cardTitle(){
            if(this.webinar.anySessionPassed){
                return this.trans('webinars.detail.session_card.after_title');
            }else{
                return this.webinar.registeredSessions.length === 0
                    ? (this.augmented ? this.trans('webinars.detail.session_card.not_registered_title') : this.trans('webinars.detail.session_card.not_registered_not_augmented_title')) 
                    : this.trans('webinars.detail.session_card.before_title')
            }

        }
    }
}
</script>

<style scoped>

</style>